



import MainBanner from '../sections/banner/template_01';







import SpeakerAnnouncement from '../sections/speaker_announcement/template_01';






import SECTION_MAINPAGE_AFFILIATE from
'../dynamic_section/dynamic_2/template_01';





import SECTION_MAINPAGE_AFFILIATE_M from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";

import FloatingIcon from '../components/FloatingIcon';
import { useEffect, useState } from "react";
import { useMiddletier } from "../common/middletier";
import { useTranslation } from 'react-i18next';

const Main = ()=>{
  const [floatingIcon, setFloatingIcon] = useState([])
  const { queries, mutation } = useMiddletier()
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    queries([
      {
        index: 'getFloatingIcons',
        method: 'getFloatingIcons',
        params: [
          { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
          { code: 'website', graphqlType: 'String', required: false, value: 'AFFILIATE' },
        ],
        attributes: []
      }
    ])
      .then(({ data }) => {
        setFloatingIcon(data['getFloatingIcons'])
      })
      .catch((error) => {
        console.error(error)
      })
  }, [queries, i18n.resolvedLanguage])
return (
<div id="main" className="page">
  
  

  
  <MainBanner navigation={ false } speed={
    2.5 } pagination={ true } />
  
  
  
  

  
  <SpeakerAnnouncement desktopToggle={ true } mobileToggle={
    true } iconToggle={ true } titleToggle={
    false } />
  
  
  
  
  {/* < SECTION_MAINPAGE_AFFILIATE desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mainPage_affiliate_step` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  < SECTION_MAINPAGE_AFFILIATE desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mainPage_affiliate_content` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  

  
  < SECTION_MAINPAGE_AFFILIATE_M desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mainPage_affiliate_step_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />

< SECTION_MAINPAGE_AFFILIATE_M desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mainPage_affiliate_content_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } /> */}
  
  < SECTION_MAINPAGE_AFFILIATE desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mainPage_affiliate` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  
  
  

  
  < SECTION_MAINPAGE_AFFILIATE_M desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mainPage_affiliate_m` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  {floatingIcon.length > 0 && (floatingIcon?.map(function (item, index) {
        return (
          <FloatingIcon position={item?._floating_icon?.position} enableClose={item?._floating_icon?.enable_close} enableMove={item?._floating_icon?.enable_move} desktopImageUrl={item?.desktop_image_url} mobileImageUrl={item?.mobile_image_url} url={item?._floating_icon?.url} />)
      }))}

  
</div>
)
}

export default Main;